module.exports = __webpack_public_path__ + "assets/img/CMTP-Website-w540.9d59eb5c.webp";